import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Setup / create tour for Add Unit page.
 */
export const addUnitTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_Setup_AddUnit_Form_Title"),
    description: t("Tour_Setup_AddUnit_Form_Description"),
    target: () => queryTourTarget("add-unit-form"),
    placement: "right",
  },
  {
    title: t("Tour_Setup_AddUnit_Submit_Title"),
    description: t("Tour_Setup_AddUnit_Submit_Description"),
    target: () => queryTourTarget("add-unit-submit"),
    placement: "top",
  },
];
